// Imports
"use client";
import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Container } from "@/components";
import { unslugify } from "@/lib/server-side-helpers";
import { useIsLargeScreen } from "@/lib/helpers";
import { Fragment } from "react";

// Breadcrumbs
export function Breadcrumbs({ paths }) {
  const { isLargeScreen } = useIsLargeScreen();
  return (
    <div className="animate-section-in">
      <Container>
        <Breadcrumb className="pb-5">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href="/">Home</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            {paths.map((path, index) => {
              const isLast = index === paths.length - 1;

              return (
                <Fragment key={index}>
                  <BreadcrumbItem>
                    {!isLast ? (
                      !isLargeScreen ? (
                        <BreadcrumbEllipsis className="w-4 h-4" />
                      ) : (
                        <BreadcrumbLink
                          className="truncate max-w-20 lg:max-w-none"
                          href={`/${paths.slice(0, index + 1).join("/")}`}
                        >
                          {unslugify(path)}
                        </BreadcrumbLink>
                      )
                    ) : (
                      <BreadcrumbPage className="truncate max-w-48 lg:max-w-none">
                        {unslugify(path)}
                      </BreadcrumbPage>
                    )}
                  </BreadcrumbItem>
                  {!isLast && <BreadcrumbSeparator />}
                </Fragment>
              );
            })}
          </BreadcrumbList>
        </Breadcrumb>
      </Container>
    </div>
  );
}
